"use strict";
exports.__esModule = true;
var ramda_1 = require("ramda");
var utils_1 = require("../utils");
var generateAppConfig = function (user) {
    var config = {};
    var scopes = user.scopes, gates = user.gates;
    var isCalendarUser = utils_1.getIsCalendarUser(scopes, gates);
    var isStandardOrAbove = utils_1.isStandardOrAboveOrg(gates) && !isCalendarUser;
    var isProOrAbove = utils_1.isProOrAboveOrg(gates) && !isCalendarUser;
    var isOrgAdmin = utils_1.getIsOrgAdmin(scopes) && !isCalendarUser;
    var isFree = utils_1.isFreeOrg(gates) && !isCalendarUser;
    var hasSavedRepliesGate = !!gates.saved_replies;
    config = ramda_1.set(ramda_1.lensProp("hasSavedReplies"), isStandardOrAbove || hasSavedRepliesGate, config);
    config = ramda_1.set(ramda_1.lensProp("hasInviteTeammates"), isStandardOrAbove, config);
    config = ramda_1.set(ramda_1.lensProp("hasSFCardInSidebar"), isProOrAbove, config);
    config = ramda_1.set(ramda_1.lensProp("hasAutosyncToSFDCToggle"), isProOrAbove, config);
    config = ramda_1.set(ramda_1.lensProp("hasInternalNotes"), isStandardOrAbove, config);
    config = ramda_1.set(ramda_1.lensProp("hasLeaveConversation"), isStandardOrAbove, config);
    config = ramda_1.set(ramda_1.lensProp("hasProspectingView"), isStandardOrAbove, config);
    config = ramda_1.set(ramda_1.lensProp("hasOptOutOfNewExperience"), isStandardOrAbove, config);
    config = ramda_1.set(ramda_1.lensProp("hasAgentAvailability"), !isCalendarUser, config);
    config = ramda_1.set(ramda_1.lensProp("hasNotificationSettings"), !isCalendarUser, config);
    config = ramda_1.set(ramda_1.lensProp("hasSearch"), !isCalendarUser, config);
    config = ramda_1.set(ramda_1.lensProp("hasReplyToConversation"), !isCalendarUser, config);
    config = ramda_1.set(ramda_1.lensProp("hasEditableEndUserAttributes"), !isCalendarUser, config);
    config = ramda_1.set(ramda_1.lensProp("hasEditableTags"), !isCalendarUser, config);
    config = ramda_1.set(ramda_1.lensProp("hasViewActivityTimeline"), !isCalendarUser, config);
    config = ramda_1.set(ramda_1.lensProp("hasShowAllConversationsInSidebar"), isFree, config);
    config = ramda_1.set(ramda_1.lensProp("hasRemoveParticipantFromConversation"), isOrgAdmin, config);
    config = ramda_1.set(ramda_1.lensProp("hasInstallWidget"), isOrgAdmin, config);
    return config;
};
exports["default"] = generateAppConfig;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@driftt/app-config/dist/appConfigs/conversationsDesktop/index.js
// module id = GJjx
// module chunks = 88